import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import { validateEmail } from '../../../Helpers/ValidatorHelper';

const EmailInputModal = ({ show, onHide }) => {
    const [email, setEmail] = useState('')
    const [error, setError] = useState('')

    const handleEmailChange = (e) => {
        setError('')
        setEmail(e.target.value)
    }

    const handleConfirmClick = () => {
        if (email.trim() == '') {
            setError('Prosze uzupełnic adres e-mail!')
            return
        }
        if (!validateEmail(email)) {
            setError('Niepoprawny format e-mail!')
            return
        }
        onHide(email)
    }

    return (
        <Modal size='lg' show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Podaj adres email do wystawiania e-faktur</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='d-flex flex-column'>
                    <Form.Control placeholder='E-mail' className='mb-3' value={email} onChange={handleEmailChange} />
                    <span className='error-text-color text-center'>{error}</span>
                    <button className='btn-app-primary ms-auto' onClick={handleConfirmClick}>Zatwierdź</button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default EmailInputModal